import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { Container } from './styles';

import Login from '../../pages/Login';
import NotFound from '../../pages/NotFound';
import ProducerReset from '../../pages/ProducerReset';
import ProducerResetConfirm from '../../pages/ProducerResetConfirm';
import PromoterReset from '../../pages/PromoterReset';
import PromoterResetConfirm from '../../pages/PromoterResetConfirm';
import Register from '../../pages/Register';

const Auth = () => (
  <Container>
    <div className="panel">
      {localStorage.getItem('token_producer') && (<Redirect to="/panel" />)}
      <Switch>
        <Route exact path="/auth" component={Login} />
        <Route exact path="/auth/register" component={Register} />
        <Route exact path="/auth/promoter/reset_password" component={PromoterReset} />
        <Route
          exact
          path="/auth/promoter/reset_password/confirm"
          component={PromoterResetConfirm}
        />
        <Route exact path="/auth/producer/reset_password" component={ProducerReset} />
        <Route
          exact
          path="/auth/producer/reset_password/confirm"
          component={ProducerResetConfirm}
        />
        <Route component={NotFound} />
      </Switch>
    </div>
  </Container>
);

export default Auth;



// WEBPACK FOOTER //
// ./src/components/Auth/index.js